import AssortmentParameterService from '@/services/assortmentparameter.service'
import AuthService from '@/services/auth.service'
import _ from 'lodash'

const state = {
    data: [],
    filterLoading: false,
    requestError: false
}

const getters = {}

const actions = {
    readAssortmentParameter: async ({ commit }, { branch }) => {
        try {
            commit('reading')
            let data = await AssortmentParameterService.readAssortmentParameter(
                branch
            )
            commit('readAssortmentParameterSuccess', data)
            return null
        } catch (e) {
            commit('readAssortmentParameterFail')
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    createSolicitation: async ({ commit }, args) => {
        try {
            await AssortmentParameterService.createSolicitation(args)
            commit('createAssortmentParameter')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },

    readAssortmentParameterSuccess(state, data) {
        let dataOrdered = _.orderBy(data, ['is_restocking_new'], ['desc'])
        state.data = dataOrdered
        state.filterLoading = false
    },

    async readAssortmentParameterFail(state) {
        await AuthService.logout()
        state.requestError = true
    },

    createAssortmentParameter(state) {
        // success
    }
}

const assortmentparameter = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default assortmentparameter
export { assortmentparameter }
